import {
  getProductPriceDisplay,
  formatProductDiscountPercentage,
  type ProductPriceSource,
} from '@eliadmin/core/src/utils/product-price-utils';

/** Customer pricing is a price tier, not a product promotion. */
export function getNtProductPriceDisplay(
  product: ProductPriceSource,
  options: Parameters<typeof getProductPriceDisplay>[1] = {},
) {
  const price = getProductPriceDisplay(product, options);
  const wholesaler = options.isWholesaler === true;
  const productDiscount = Number(product.discounts?.product?.effective_percentage ?? 0);
  const promotion = wholesaler
    ? product.discounts?.visible !== false &&
      Number.isFinite(productDiscount) &&
      productDiscount > 0
    : price.showPreviousPrice;
  return {
    ...price,
    showPreviousPrice: !wholesaler && price.showPreviousPrice,
    showPromotion: !price.priceOnRequest && promotion,
    promotionDiscountLabel: wholesaler
      ? formatProductDiscountPercentage(productDiscount)
      : price.discountLabel,
  };
}
